import { useContext } from 'react';
import { useIntl } from 'react-intl';

import { FocusRingVariants, FontSizes, FontWeights, Text } from '@calm-web/design-system';

import StarRating from '@/components/ui/StarRating';
import { useAnalytics } from '@/hooks/analytics';

import AnimatedScreenWrapper from '../../Components/AnimatedScreenWrapper';
import { PreSignupFlowContext } from '../../PreSignupProvider';
import { Content, ContentWrapper, ContinueButton, Quote, Wrapper } from './styles';

const TestimonialScreen = () => {
	const { formatMessage } = useIntl();
	const { logEvent } = useAnalytics();

	const { nextScreen, ActiveScreen } = useContext(PreSignupFlowContext);
	const { quote, author, transitionType } = ActiveScreen;

	const onContinue = async () => {
		logEvent({
			eventName: 'FTUE : Transition : Proceeded',
			eventProps: {
				transition_type: transitionType as string,
			},
		});
		nextScreen();
	};

	return (
		<AnimatedScreenWrapper>
			<Wrapper>
				<ContentWrapper>
					<Content>
						<StarRating />
						{quote && (
							<blockquote>
								<Quote el="p" color="black" weight={FontWeights.Regular}>
									{formatMessage(quote)}
								</Quote>
							</blockquote>
						)}
						{author && (
							<Text el="p" color="black" size={FontSizes.sm} weight={FontWeights.Medium}>
								{formatMessage(author)}
							</Text>
						)}
					</Content>
					<ContinueButton
						onContinue={onContinue}
						continueButtonStyle={{
							backgroundColor: 'accessibleBrandGradient',
							textColor: 'white',
						}}
						focusRingVariant={FocusRingVariants.Light}
					/>
				</ContentWrapper>
			</Wrapper>
		</AnimatedScreenWrapper>
	);
};

export default TestimonialScreen;
